export default __webpack_public_path__ + "static/media/visa-icon.b0737242.png";